var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #CDCFD4;\n      }\n\n      .cls-2 {\n        fill: #2d3544;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "video-pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    className: "cls-1",
    d: "M683,369h0a15,15,0,0,1,15,15h0a15,15,0,0,1-15,15h0a15,15,0,0,1-15-15h0A15,15,0,0,1,683,369Z",
    transform: "translate(-668 -369)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-2",
    d: "M677.5,378.5v11h4v-11Z",
    transform: "translate(-668 -369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    className: "cls-2",
    d: "M684.5,378.5v11h4v-11Z",
    transform: "translate(-668 -369)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPause);
export default __webpack_public_path__ + "static/media/video-pause.9db7d41a6ed653c440a6ec4489444643.svg";
export { ForwardRef as ReactComponent };